import { FC } from "react";
import {
  AspectRatio,
  Box,
  Card,
  IconButton,
  Stack,
  Typography,
} from "@mui/joy";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

type ProjectCardPropsType = { image: string; title: string; link?: string };

export const ProjectCard: FC<ProjectCardPropsType> = ({
  image,
  title,
  link,
}) => {
  const { t } = useTranslation();

  return (
    <Card
      variant="outlined"
      sx={{
        p: 1,
        overflow: "hidden",
        bgcolor: "background.surface",
        backdropFilter: "blur(14px)",
        borderColor: "divider",
        boxShadow: "sm",
        transition: "0.25s ease",
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: "lg",
          borderColor: "primary.300",
        },
      }}
    >
      <AspectRatio
        ratio="16/10"
        sx={{ borderRadius: "20px", overflow: "hidden" }}
      >
        <img src={image} alt={t(title) || "image"} loading="lazy" />
      </AspectRatio>

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        sx={{ pt: 1 }}
      >
        <Box minWidth={0}>
          <Typography level="title-md" noWrap>
            {t(title)}
          </Typography>
          <Typography level="body-xs" sx={{ color: "text.tertiary" }}>
            Featured project
          </Typography>
        </Box>

        {link && (
          <IconButton
            component={Link as any}
            to={link}
            target="_blank"
            color="primary"
            variant="soft"
            sx={{ borderRadius: "50%", flexShrink: 0 }}
          >
            ↗
          </IconButton>
        )}
      </Stack>
    </Card>
  );
};
